import domReady from '@roots/sage/client/dom-ready';
import 'jquery';

import './alpine.js';
import './common.js';
import 'flowbite';
import 'flowbite/dist/datepicker.js';
import 'leaflet';
import 'leaflet.markercluster';
import 'select2';

import './components/benefits.js';
import './components/destinations.js';
import './components/blogSidebar.js';
import './components/accordian.js';
import './components/listing-benefits.js';
import './components/platforms.js';
import './components/reviews.js';
import './components/video.js';
import './components/header.js';
import './components/listProperty.js';
import './components/customerSwiper.js';
import './components/blogSlider.js';
import './components/locationCta.js';
import './components/propertyCard.js';
import './components/propertyGallery.js';
import './components/checkout.js';
import './components/propertyFilters.js';
import './components/search.js';
import './components/playVideo.js';
import './components/heroVideo.js';
import './components/accountForms.js';
import './components/datepicker.js';

/**
 * Application entrypoint
 */
domReady(async () => {
  // ...
});

/**
 * @see {@link https://webpack.js.org/api/hot-module-replacement/}
 */
if (import.meta.webpackHot) import.meta.webpackHot.accept(console.error);